export const NOTE_TYPES = ['conversation', 'workflow', 'case_action'] as const;
export type NoteType = (typeof NOTE_TYPES)[number];

interface TimelineEntryBase {
    id: string;
    occurredAt: string;
    actorType: string | null;
    actorId: string | null;
    actorName: string | null;
    crmCaseId: string | null;
}

export interface NoteTimelineEntry extends TimelineEntryBase {
    kind: 'note';
    note: { id: string; noteType: NoteType | string; body: string; crmCaseId: string | null };
}

export interface UnknownTimelineEntry extends TimelineEntryBase {
    kind: 'unknown';
    entryType: string;
}

export type AgreementTimelineEntry = NoteTimelineEntry | UnknownTimelineEntry;

export interface TimelineMeta {
    currentPage: number;
    lastPage: number;
    perPage: number;
    total: number;
}

export interface NotesPage {
    entries: AgreementTimelineEntry[];
    meta: TimelineMeta;
}

/** The history feed records THAT a note was added; the body is served only by
 *  `/notes`, so a note event carries no note object at all. */
export interface NoteAddedHistoryEvent extends TimelineEntryBase {
    kind: 'note_added';
}

export interface StateChangeHistoryEvent extends TimelineEntryBase {
    kind: 'state_change';
    stateChange: { fromState: string | null; toState: string; reason: string | null };
}

export interface TopUpAddedHistoryEvent extends TimelineEntryBase {
    kind: 'top_up_added';
    topUp: { amount: string; reference: string; takingDealerId: string | null; takingDealerName: string | null };
}

export type MotorplanPaymentType = 'deposit' | 'pay_now' | 'ad_hoc';

export interface MotorplanPaymentHistoryEvent extends TimelineEntryBase {
    kind: 'motorplan_payment_received' | 'motorplan_payment_failed';
    amount: string;
    paymentType: MotorplanPaymentType | null;
}

export interface PaymentLinkHistoryChannel {
    channel: 'email' | 'text';
    suppressed: boolean;
}

export interface PaymentLinkCreatedHistoryEvent extends TimelineEntryBase {
    kind: 'payment_link_created';
    paymentLink: { amount: string; paysOff: boolean; channels: PaymentLinkHistoryChannel[] };
}

export type AgreementHistoryEvent =
    | NoteAddedHistoryEvent
    | StateChangeHistoryEvent
    | TopUpAddedHistoryEvent
    | MotorplanPaymentHistoryEvent
    | PaymentLinkCreatedHistoryEvent
    | UnknownTimelineEntry;

export interface HistoryPage {
    entries: AgreementHistoryEvent[];
    meta: TimelineMeta;
}

export interface AddNoteInput {
    noteType: NoteType;
    body: string;
    crmCaseId?: string;
}
